import { cn } from "$/lib/utils/functions/misc.functions";

import type { TimePickerProps } from "../TimePicker.types";

const DropdownClassName =
  "block h-12 rounded-lg border-gray-200 bg-gray-100 px-4 py-3 pe-7 text-sm focus:border-primary focus:ring-primary disabled:pointer-events-none disabled:opacity-50";

export const Option2 = ({ value, onChange }: TimePickerProps) => {
  return (
    <>
      <select
        className={cn(DropdownClassName)}
        onChange={(e) =>
          onChange({ ...value, hours: parseInt(e.target.value) })
        }
        value={value.hours}
      >
        {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
          <option key={hour} value={hour}>
            {hour}
          </option>
        ))}
      </select>

      <span className="font-bold">:</span>

      <select
        className={cn(DropdownClassName)}
        onChange={(e) =>
          onChange({ ...value, minutes: parseInt(e.target.value) })
        }
        value={value.minutes}
      >
        {Array.from({ length: 61 }, (_, i) => i).map((minute) => (
          <option key={minute} value={minute}>
            {minute}
          </option>
        ))}
      </select>

      <span className="font-bold">:</span>

      <select
        className={cn(DropdownClassName)}
        onClick={() =>
          onChange({ ...value, period: value.period === "am" ? "pm" : "am" })
        }
        value={value.period}
      >
        <option value="am">AM</option>
        <option value="pm">PM</option>
      </select>
    </>
  );
};
